/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_None_AllowedInputs */

const cs_portals_none_allowed = /** @type {(inputs: Portals_None_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný portál není v kanceláři povolen. Správce je zapne v Integracích.`)
};

const en_portals_none_allowed = /** @type {(inputs: Portals_None_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No listing portals are allowed for this office. An admin enables them under Integrations.`)
};

/**
* | output |
* | --- |
* | "No listing portals are allowed for this office. An admin enables them under Integrations." |
*
* @param {Portals_None_AllowedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_none_allowed = /** @type {((inputs?: Portals_None_AllowedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_None_AllowedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_none_allowed(inputs)
	return cs_portals_none_allowed(inputs)
});